import { call, put, takeLatest, all } from 'redux-saga/effects';
import { stopSubmit } from 'redux-form';

import { actions } from 'store/deviceReducer';
import { setPaginationFor } from 'store/pagination-reducer';
import * as notify from 'components/ui/Notify/store/actions';
import DeviceMapper from 'mappers/device-mapper';

const setDevicesPagination = setPaginationFor('DEVICES');

function* fetchDevices(action) {
  const params = action.payload;
  try {
    const res = yield call(DeviceMapper.fetchAll, params);
    yield put(actions.fetchDevicesSuccess(res.data.devices));
    yield put(setDevicesPagination(res));
  } catch(err) {
    yield put(actions.fetchDevicesFail(err.response.data.error));
  }
}

function* watchFetchDevices() {
  yield takeLatest(actions.fetchDevices().type, fetchDevices)
}

function* fetchDevice(action) {
  try {
    const res = yield call(DeviceMapper.fetchOne, action.payload);
    yield put(actions.fetchDeviceSuccess(res.data.device));
  } catch(err) {
    yield put(actions.fetchDeviceFail(err.response.data.error));
  }
}

function* watchFetchDevice() {
  yield takeLatest(actions.fetchDevice().type, fetchDevice);
}

function* createDevice(action) {
  try {
    yield call(DeviceMapper.create, {device: action.payload[0]});
    yield put(notify.actions.success('Device was successfully created.'));
    yield call(action.payload[1]);
  } catch(err) {
    yield put(actions.createUserFail(err.response.data.error));
    yield put(stopSubmit('device', err.response.data.error.message));
  }
}

function* watchCreateDevice() {
  yield takeLatest(actions.createDevice().type, createDevice)
}

function* updateDevice(action) {
  const device = action.payload[0]
  try {
    yield call(DeviceMapper.patch, device.id, { device });
    yield put(notify.actions.success('Device was successfully updated.'));
    yield call(action.payload[1]);
  } catch(err) {
    yield put(actions.updateDeviceFail(err.response.data.error));
    yield put(stopSubmit('device', err.response.data.error.message));
  }
}

function* watchUpdateDevice() {
  yield takeLatest(actions.updateDevice().type, updateDevice);
}

function* deleteDevice(action) {
  try {
    const res = yield call(DeviceMapper.delete, action.payload);
    yield put(actions.deleteDeviceSuccess(res.data.device));
    yield put(notify.actions.success('Device was successfully deleted.'));
  } catch(err) {
    yield put(actions.deleteDeviceFail(err.response.data.error));
    yield put(notify.actions.error(err.response.data.error.message));
  }
}

function* watchDeleteDevice() {
  yield takeLatest(actions.deleteDevice().type, deleteDevice)
}

export default function* deviceSaga() {
  yield all([
    watchFetchDevices(),
    watchFetchDevice(),
    watchCreateDevice(),
    watchUpdateDevice(),
    watchDeleteDevice(),
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/deviceSaga.js